// A best practice for URL structures is to define
// long-names with dash instead of underscores:
// https://developers.google.com/search/docs/crawling-indexing/url-structure
const routes = {
  home: '/',
  root: '/dashboard',
  login: '/login',
  dashboard: '/dashboard',
  map: '/map',
  can: '/can/:type(dashboard)',
  canDashboard: '/can/dashboard',
  huella: '/huella/:type(dashboard|ralenti)',
  huellaDashboard: '/huella/dashboard',
  huellaRalenti: '/huella/ralenti',
  cycles: '/cycles/:type(cycles)',
  cyclesCycles: '/cycles/cycles',
  times: '/times/:type(times)',
  timesTimes: '/times/times',
  orders: '/orders/:type(order)',
  ordersOrder: '/orders/order',
  reports: '/reports/:type(report)',
  reportsReport: '/reports/report',
  productivity: '/productivity/:type(kpitree)',
  productivityKpitree: '/productivity/kpitree',
  fronts: '/fronts',
  userManual: '/user-manual',
  notifications: '/notifications',
  diagram: '/diagram',
  devices: '/devices',
  passwordRecovery: '/recover-password',
  kepler: '/kepler-map',
};

export default routes;
